import { lazy, Suspense } from 'react';

const LazyRegisterComplete = lazy(() => import('./RegisterComplete'));

const RegisterComplete = () => (
  <Suspense fallback={null}>
    <LazyRegisterComplete />
  </Suspense>
);

export default RegisterComplete;
